<script setup>
import {useStore} from "vuex";
import {computed} from "vue";

const store = useStore();

const currentStep = computed(() => store.getters['tours/currentStepNumber']);
const totalSteps = computed(() => store.getters['tours/totalSteps']);

</script>

<template>
  <span class="tw-text-sm">{{ `Step ${currentStep} of ${totalSteps}` }}</span>
</template>